import React from 'react';
import '../styles/EntitySelector.css';

function EntitySelector({ entities, selectedEntity, onSelectEntity }) {
  const handleChange = (e) => {
    const entityName = e.target.value;
    const entity = entities.find(ent => ent.name === entityName);
    if (entity && entity.enabled) {
      onSelectEntity(entity);
    }
  };

  return (
    <div className="entity-selector">
      <label htmlFor="entity-dropdown" className="entity-label">
        Select Entity:
      </label>
      <select
        id="entity-dropdown"
        className="entity-dropdown"
        value={selectedEntity?.name || ''}
        onChange={handleChange}
      >
        <option value="" disabled>-- Select Entity --</option>
        {entities.map((entity) => (
          <option
            key={entity.name}
            value={entity.name}
            disabled={!entity.enabled}
            className={entity.enabled ? '' : 'disabled-option'}
          >
            {entity.finalyzer_company_code} - {entity.name} {!entity.enabled ? '(Disabled)' : ''}
          </option>
        ))}
      </select>

      {selectedEntity && (
        <div className="selected-entity-info">
          <p><strong>Company Code:</strong> {selectedEntity.finalyzer_company_code}</p>
          <p><strong>Description:</strong> {selectedEntity.description}</p>
          <p><strong>Database:</strong> {selectedEntity.sap_database}</p>
        </div>
      )}
    </div>
  );
}

export default EntitySelector;
